import { createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import rootred from './redux/reducers/main';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';



// const store = createStore(rootred, composeWithDevTools());

// export default store;

const persistConfig = {
    key: 'root',
    storage,
  }
 
  
  const persistedReducer = persistReducer(persistConfig, rootred)

  let store = createStore(persistedReducer, composeWithDevTools())
// const store = createStore(
//     rootred
// );
let persistor = persistStore(store)

export {persistor};
export default store;